var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaykaInformationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#19297C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08 4.57082C5.92533 4.57082 5.8 4.52549 5.704 4.43482C5.608 4.33882 5.56 4.21615 5.56 4.06682C5.56 3.91749 5.608 3.79749 5.704 3.70682C5.8 3.61082 5.92533 3.56282 6.08 3.56282C6.23467 3.56282 6.35733 3.61082 6.448 3.70682C6.544 3.79749 6.592 3.91749 6.592 4.06682C6.592 4.21615 6.544 4.33882 6.448 4.43482C6.35733 4.52549 6.23467 4.57082 6.08 4.57082ZM5.704 5.09882H6.448V9.09082H5.704V5.09882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaykaInformationIcon);
export default __webpack_public_path__ + "static/media/payka-information-icon.dca18926b2a97725580271b95cb0429f.svg";
export { ForwardRef as ReactComponent };